import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/lib/auth";
import { LanguageProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";

import HomePage from "@/pages/HomePage";
import SchedulePage from "@/pages/SchedulePage";
import TeamsPage from "@/pages/TeamsPage";
import TeamDetailPage from "@/pages/TeamDetailPage";
import LiveGamePage from "@/pages/LiveGamePage";
import MatchSummaryPage from "@/pages/MatchSummaryPage";
import StandingsPage from "@/pages/StandingsPage";
import MatchPage from "@/pages/MatchPage";
import ScorersPage from "@/pages/ScorersPage";
import PlayoffsPage from "@/pages/PlayoffsPage";
import NewsPage from "@/pages/NewsPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import GalleryPage from "@/pages/GalleryPage";
import PartnersPage from "@/pages/PartnersPage";
import RulesPage from "@/pages/RulesPage";
import InfoPage from "@/pages/InfoPage";
import ContactPage from "@/pages/ContactPage";
import InscriptionPage from "@/pages/InscriptionPage";
import InscriptionSuccessPage from "@/pages/InscriptionSuccessPage";
import TeamLoginPage from "@/pages/TeamLoginPage";
import TeamDashboardPage from "@/pages/TeamDashboardPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminTeams from "@/pages/admin/AdminTeams";
import AdminRosters from "@/pages/admin/AdminRosters";
import AdminScores from "@/pages/admin/AdminScores";
import AdminSchedule from "@/pages/admin/AdminSchedule";
import AdminLineup from "@/pages/admin/AdminLineup";
import AdminNews from "@/pages/admin/AdminNews";
import AdminPartners from "@/pages/admin/AdminPartners";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminRegistrations from "@/pages/admin/AdminRegistrations";

const Public = ({ children }) => <Layout>{children}</Layout>;

function App() {
    return (
        <HelmetProvider>
            <LanguageProvider>
                <AuthProvider>
                    <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Public><HomePage /></Public>} />
                        <Route path="/horaire" element={<Public><SchedulePage /></Public>} />
                        <Route path="/equipes" element={<Public><TeamsPage /></Public>} />
                        <Route path="/equipes/:id" element={<Public><TeamDetailPage /></Public>} />
                        <Route path="/classement" element={<Public><StandingsPage /></Public>} />
                        <Route path="/match/:num" element={<Public><MatchPage /></Public>} />
                        <Route path="/pointeurs" element={<Public><ScorersPage /></Public>} />
                        <Route path="/eliminatoires" element={<Public><PlayoffsPage /></Public>} />
                        <Route path="/nouvelles" element={<Public><NewsPage /></Public>} />
                        <Route path="/nouvelles/:id" element={<Public><NewsDetailPage /></Public>} />
                        <Route path="/galerie" element={<Public><GalleryPage /></Public>} />
                        <Route path="/partenaires" element={<Public><PartnersPage /></Public>} />
                        <Route path="/reglements" element={<Public><RulesPage /></Public>} />
                        <Route path="/infos" element={<Public><InfoPage /></Public>} />
                        <Route path="/contact" element={<Public><ContactPage /></Public>} />
                        <Route path="/inscription" element={<Public><InscriptionPage /></Public>} />
                        <Route path="/inscription/succes" element={<Public><InscriptionSuccessPage /></Public>} />
                        <Route path="/equipe/login" element={<Public><TeamLoginPage /></Public>} />
                        <Route path="/equipe" element={<Public><TeamDashboardPage /></Public>} />
                        <Route path="/live/:num" element={<Public><LiveGamePage /></Public>} />
                        <Route path="/match/:num/sommaire" element={<Public><MatchSummaryPage /></Public>} />

                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="users" element={<AdminUsers />} />
                            <Route path="teams" element={<AdminTeams />} />
                            <Route path="rosters" element={<AdminRosters />} />
                            <Route path="scores" element={<AdminScores />} />
                            <Route path="horaire" element={<AdminSchedule />} />
                            <Route path="lineup/:num" element={<AdminLineup />} />
                            <Route path="news" element={<AdminNews />} />
                            <Route path="partners" element={<AdminPartners />} />
                            <Route path="gallery" element={<AdminGallery />} />
                            <Route path="registrations" element={<AdminRegistrations />} />
                            <Route path="settings" element={<AdminSettings />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            </LanguageProvider>
        </HelmetProvider>
    );
}

export default App;
